export default __webpack_public_path__ + "static/media/OrangeCelebrationSquiggles.6810cefb.png";